import { render, staticRenderFns } from "./ShopMenuOrderList.vue?vue&type=template&id=6cc13521&"
import script from "./ShopMenuOrderList.vue?vue&type=script&lang=js&"
export * from "./ShopMenuOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ShopMenuOrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports